import { Grid } from "@mui/material";
import { Control } from "react-hook-form";
import { useGetInvoiceConstant } from "../api/invoice/constant/resolver";
import useGenerateOptions, {
  useGenerateArrayFromObj,
} from "../../../components/input/hook/useGenerateOptions2";
import Input from "../../../components/input/Input-v2";
import { useNavigate } from "react-router";
import { KEY_URL_PARAM, MainFilterGroupForm } from "../pages/Main";
import { useGetSubDealers } from "../../dealer/api/supplier/resolver";
import { useState } from "react";

interface MainFilterGroup {
  control: Control<MainFilterGroupForm, any>;
}

export default function MainFilterGroup({ control }: MainFilterGroup) {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const { data: dataRawInvoiceConstant, isLoading: fetchInvoiceConstant } =
    useGetInvoiceConstant();
  const dataInvoiceConstant = dataRawInvoiceConstant?.data.data;
  const { data: dataInvoiceType } = useGenerateArrayFromObj({
    dataSource: dataInvoiceConstant?.type,
  });
  const { data: dataInvoiceStatus } = useGenerateArrayFromObj({
    dataSource: dataInvoiceConstant?.status,
  });
  const { data: dataRawSubDealer, isLoading: fetchDealer } = useGetSubDealers({
    keyword,
  });
  const dataSubDealer = dataRawSubDealer?.data.data.data;
  const { data: dataSubDealerOptions } = useGenerateOptions({
    dataSource: dataSubDealer,
    keyForText: "sub_dealer_name",
    keyForValue: "id",
  });
  const isFetching = fetchInvoiceConstant || fetchDealer;

  const handleChangeValue = (key: string, value: string) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set(key, value); // Append or update param
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        <Input.Controller
          control={control}
          name="customer_name"
          render={(field) => (
            <Input.Text
              isFetching={isFetching}
              label="Nama Customer"
              value={field.value}
              onChange={(e) => {
                field.onChange(e);
                handleChangeValue(KEY_URL_PARAM.customer_name, e);
              }}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <Input.Controller
          control={control}
          name="sub_dealer_id"
          render={(field) => (
            <Input.Autocomplete
              isFetching={isFetching}
              label="Sub Dealer"
              options={dataSubDealerOptions || []}
              value={field.value}
              onChange={(e) => setKeyword(e)}
              onClick={(e) => {
                field.onChange(e.value);
                handleChangeValue(KEY_URL_PARAM.sub_dealer_id, e.value);
              }}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <Input.Controller
          control={control}
          name="invoice_type"
          render={(field) => (
            <Input.Select
              isFetching={isFetching}
              label="Tipe Invoice"
              options={dataInvoiceType || []}
              value={field.value}
              onChange={(e) => {
                field.onChange(e.value);
                handleChangeValue(KEY_URL_PARAM.invoice_type, e.value);
              }}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <Input.Controller
          control={control}
          name="status"
          render={(field) => (
            <Input.Select
              isFetching={isFetching}
              label="Status Invoice"
              options={dataInvoiceStatus || []}
              value={field.value}
              onChange={(e) => {
                field.onChange(e.value);
                handleChangeValue(KEY_URL_PARAM.status, e.value);
              }}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Input.Controller
          control={control}
          name="start_date"
          render={(field) => (
            <Input.Date
              label="Tanggal Awal"
              value={field.value}
              onChange={(e) => {
                field.onChange(e);
                handleChangeValue(KEY_URL_PARAM.start_date, e);
              }}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Input.Controller
          control={control}
          name="end_date"
          render={(field) => (
            <Input.Date
              label="Tanggal Ahkir"
              value={field.value}
              onChange={(e) => {
                field.onChange(e);
                handleChangeValue(KEY_URL_PARAM.end_date, e);
              }}
            />
          )}
        />
      </Grid>
    </Grid>
  );
}
